import { PlusOutlined } from "@ant-design/icons";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
} from "@components";

import { PATH_ADD_CLINIC, adminFilter } from "@configs";
import { ClinicTable } from "@modules/clinic";
import { selectApp } from "@redux";
import { useClinicListPage } from "@utils";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

export const PageClinic = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { mobile } = useSelector(selectApp);

  const {
    data,
    total,
    page,
    filters,
    date,
    refetch,
    handleDateFilter,
    handlePagination,
    changeFilter,
    searchText,
    handleClearSearch,
    handleClearDate,
  } = useClinicListPage();

  const goToCreate = () => history.push(PATH_ADD_CLINIC);

  const button = (
    <Tooltip title={t("page.add_clinic")}>
      {mobile ? (
        <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
      ) : (
        <SharedButton
          type="primary"
          ghost
          icon={<PlusOutlined />}
          size="middle"
          onClick={goToCreate}
        >
          {t("page.add_clinic")}
        </SharedButton>
      )}
    </Tooltip>
  );

  return (
    <>
      <ComponentHeader title={t("page.clinic")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={adminFilter}
            callbackFun={changeFilter}
            onDateChange={handleDateFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            handleClearDate={handleClearDate}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <ClinicTable data={data} callback={refetch} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
